import BaseView from 'components-framework/view/base.view';
import {dispatch} from 'od-modules/secure_store/store';
import {updateMembership} from 'od-modules/secure_store/reducers/asyncActionCreators';
const {revampTrackingLabel} = require('od-modules/utils/membership_tracking.utils').default;

const actions = require('od-modules/secure_store/actions');

const View = BaseView.extend({
    initialize() {
        this.listenTo(this.model, 'change:isRiskyCard', this.renderMessage);
        this.listenTo(this.model, 'change:pricing', this.updateWarningMessage);
    },

    renderMessage(model) {
        if (model.get('isRiskyCard')) {
            return this.renderWarningMessage();
        } else if (model.previous('isRiskyCard') !== model.get('isRiskyCard')) {
            return this.renderSuccessMessage();
        }
    },

    updateWarningMessage() {
        this.model.get('isRiskyCard') && this.renderWarningMessage();
    },

    isSubscriptionAdded() {
        const primeMemberSelected = this.model.get('primeMemberSelected');
        return primeMemberSelected && primeMemberSelected.isSubscriptionAdded;
    },

    renderWarningMessage() {
        const {totalPrice} = this.model.get('pricing');
        this.keys.warningDescriptionWithFullPrice = Odigeo.Utils.replaceCmsKeyArgs(this.keys.warningDescription, totalPrice.toFixed(2));
        if (this.isSubscriptionAdded()) {
            this.$el.html(this.templates.warningMessage({keys: this.keys}));
        }
        return Odigeo.Utils.isMobile()
            ? this.editPrime(false)
            : Odigeo.trigger(`${this.id}:riskyCreditCardDetected`) && Odigeo.trigger(`${this.id}:scrollToRiskyCardWarningMessage`);
    },

    getPrimeMemberSelectedUpdateDispatch(isAdd) {
        return {
            type: actions.SET_PRIME_MEMBER_SELECTED,
            entry: {
                isAddedInPayment: isAdd,
                isSubscriptionAdded: isAdd,
                ccStatus: isAdd ? 'validated' : 'invalid',
            },
            merge: true,
        };
    },

    editPrime(isAdd) {
        dispatch(this.getPrimeMemberSelectedUpdateDispatch(isAdd));
        dispatch(updateMembership);
        revampTrackingLabel('addPrimeCCEvaluation');
        if (!isAdd) {
            this.scrollToWarningMessage();
        }
    },

    renderSuccessMessage() {
        this.$el.html(this.templates.successMessage({keys: this.keys}));
        if (!this.isSubscriptionAdded()) {
            return Odigeo.Utils.isMobile() ? this.editPrime(true) : Odigeo.trigger(`${this.id}:riskyCreditCardCleared`);
        }
    },

    hideBlockingBinsSuccessMessage() {
        this.$el.find('.block_risky_cards_msg_positive').hide();
    },

    scrollToWarningMessage() {
        Odigeo.Utils.scrollToElement(this.$el);
    },
});

export default View;
